import { render, staticRenderFns } from "./vrVideo.vue?vue&type=template&id=8ee47da6&scoped=true&"
import script from "./vrVideo.vue?vue&type=script&lang=ts&"
export * from "./vrVideo.vue?vue&type=script&lang=ts&"
import style0 from "./vrVideo.vue?vue&type=style&index=0&id=8ee47da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee47da6",
  null
  
)

export default component.exports